import { render } from "./SurveyDiffCard.vue?vue&type=template&id=0c6c1c67&scoped=true"
import script from "./SurveyDiffCard.vue?vue&type=script&lang=js"
export * from "./SurveyDiffCard.vue?vue&type=script&lang=js"

import "./SurveyDiffCard.vue?vue&type=style&index=0&id=0c6c1c67&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6c1c67"]])

export default __exports__